module.exports = __webpack_public_path__ + "img/icon-income.e0dda756.svg";